import { render, staticRenderFns } from "./IDMLPagePreview.vue?vue&type=template&id=5dfff46e&scoped=true"
import script from "./IDMLPagePreview.vue?vue&type=script&lang=js"
export * from "./IDMLPagePreview.vue?vue&type=script&lang=js"
import style0 from "./IDMLPagePreview.vue?vue&type=style&index=0&id=5dfff46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfff46e",
  null
  
)

export default component.exports